import React, { useState } from "react";
import client from "../lib/api";
import { toast } from "sonner";

const STATUSES = ["new", "confirmed", "completed", "cancelled"];

const Admin = () => {
  const [password, setPassword] = useState("");
  const [authed, setAuthed] = useState(false);
  const [tab, setTab] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [requests, setRequests] = useState([]);

  const load = async (pw) => {
    const p = pw || password;
    const [o, c] = await Promise.all([
      client.get(`/admin/orders?password=${encodeURIComponent(p)}`),
      client.get(`/admin/catering?password=${encodeURIComponent(p)}`),
    ]);
    setOrders(o.data.orders);
    setRequests(c.data.requests);
  };

  const login = async (e) => {
    e.preventDefault();
    try {
      await client.post("/admin/login", { password });
      await load(password);
      setAuthed(true);
    } catch (err) {
      toast.error("Invalid admin password");
    }
  };

  const setOrderStatus = async (num, status) => {
    try {
      await client.post(`/admin/orders/${num}/status?password=${encodeURIComponent(password)}`, { status });
      toast.success(`Order ${num} → ${status}`);
      load();
    } catch (e) { toast.error("Failed"); }
  };

  const setCateringStatus = async (id, status) => {
    try {
      await client.post(`/admin/catering/${id}/status?password=${encodeURIComponent(password)}`, { status });
      toast.success(`Request → ${status} (customer emailed)`);
      load();
    } catch (e) { toast.error("Failed"); }
  };

  if (!authed) {
    return (
      <div className="max-w-sm mx-auto px-4 pt-28 pb-24">
        <h1 className="font-heading text-2xl font-bold text-[#2c1e12] text-center">Owner Admin</h1>
        <form onSubmit={login} className="mt-5 space-y-3">
          <input type="password" placeholder="Admin password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl bg-[#f6ece0] border border-[#e6d8bf] px-4 py-3 text-[#2c1e12] focus:outline-none focus:ring-2 focus:ring-[#9a4a2f]/40" />
          <button className="w-full rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold py-3">Enter</button>
        </form>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 pt-20 pb-24">
      <h1 className="font-heading text-3xl font-bold text-[#2c1e12]">Admin</h1>
      <div className="flex gap-2 mt-4">
        {["orders", "catering"].map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`rounded-full px-5 py-2 text-sm font-medium capitalize ${tab === t ? "bg-[#9a4a2f] text-white" : "bg-[#efe3cd] text-[#4a3524]"}`}>{t}</button>
        ))}
      </div>

      {tab === "orders" ? (
        <div className="mt-5 space-y-3">
          {orders.length === 0 && <p className="text-[#8a7458]">No orders.</p>}
          {orders.map((o) => (
            <div key={o.order_number} className="rounded-2xl bg-[#f6ece0] p-4">
              <div className="flex justify-between">
                <div>
                  <p className="font-semibold text-[#2c1e12]">{o.order_number} · ${o.total.toFixed(2)}</p>
                  <p className="text-xs text-[#8a7458]">{o.customer.first_name} {o.customer.last_name} · {o.customer.email} · {o.customer.phone}</p>
                  <p className="text-xs text-[#8a7458]">{o.fulfillment_type} on {o.fulfillment_date} · {o.items.map((i) => `${i.qty}×${i.name}`).join(", ")}</p>
                </div>
                <span className="text-xs font-semibold capitalize text-[#9a4a2f]">{o.status}</span>
              </div>
              <div className="flex gap-1.5 mt-2 flex-wrap">
                {STATUSES.map((s) => (
                  <button key={s} onClick={() => setOrderStatus(o.order_number, s)} className={`text-xs rounded-full px-3 py-1 capitalize ${o.status === s ? "bg-[#9a4a2f] text-white" : "bg-white text-[#4a3524] border border-[#e6d8bf]"}`}>{s}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-5 space-y-3">
          {requests.length === 0 && <p className="text-[#8a7458]">No catering requests.</p>}
          {requests.map((r) => (
            <div key={r.request_id} className="rounded-2xl bg-[#f6ece0] p-4">
              <div className="flex justify-between">
                <div>
                  <p className="font-semibold text-[#2c1e12]">{r.package_name} · {r.headcount || "?"} ppl</p>
                  <p className="text-xs text-[#8a7458]">{r.first_name} {r.last_name} · {r.email} · {r.phone}</p>
                  <p className="text-xs text-[#8a7458]">{r.event_type} · {r.event_date} · {r.fulfillment_type} · deposit ${r.deposit?.toFixed(2)}</p>
                  {r.special_requests && <p className="text-xs text-[#8a7458] italic">{r.special_requests}</p>}
                </div>
                <span className="text-xs font-semibold capitalize text-[#9a4a2f]">{r.status}</span>
              </div>
              <div className="flex gap-1.5 mt-2 flex-wrap">
                {STATUSES.map((s) => (
                  <button key={s} onClick={() => setCateringStatus(r.request_id, s)} className={`text-xs rounded-full px-3 py-1 capitalize ${r.status === s ? "bg-[#9a4a2f] text-white" : "bg-white text-[#4a3524] border border-[#e6d8bf]"}`}>{s}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Admin;
